import React from "react";
import { Clock, DollarSign, Layers, LogOut, Settings } from "react-feather";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import logo from "../../assets/images/logo.png";
import { NavLink } from "react-router-dom";
import { useQueryClient } from "react-query";
import { sessionKey } from "../../services/ApiService";
import Button from "@cs/components/src/Button";

interface Props {
  showLinks: boolean;
  systemDomainId: string | undefined;
}

const Spacer = styled.div`
  flex: 1;
`;

const StyledHeader = styled.div`
  background-color: var(--dark060);
  height: 50px;
  color: var(--gray200);
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.39);

  > a {
    flex-shrink: 0;
  }
`;

const Logo = styled.img`
  height: 30px;
  margin-top: 5px;
  margin-right: 10px;
`;

const HeaderLink = styled(NavLink)`
  margin-left: 15px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 500;

  svg {
    margin-right: 5px;
  }

  span {
    display: none;
  }

  &.active {
    color: var(--blue400);
  }

  @media (min-width: 600px) {
    margin-left: 25px;

    span {
      display: block;
    }
  }
`;

const Header = (props: Props) => {
  const { showLinks, systemDomainId } = props;
  const queryClient = useQueryClient();

  const signOut = () => {
    localStorage.removeItem(sessionKey);
    queryClient.invalidateQueries(["session"]);
  };

  // const location = useLocation();

  // let path = 'plugin';
  // // if (location.pathname.includes('/plugin/')) {
  // //   path = location.pathname.replace(/^.*\/(plugin\/[^/]*).*$/, '$1');
  // // }
  // if (location.pathname.includes('/script')) {
  //   path = 'script';
  // }
  // if (location.pathname.includes('/script/') && !location.pathname.includes('/job')) {
  //   path = location.pathname.replace(/^.*\/(script\/[^/]*).*$/, '$1');
  // }

  return (
    <StyledHeader>
      <Link to="/dashboard">
        <Logo src={logo} alt="cinesys.io" />
      </Link>
      {showLinks && (
        <>
          <HeaderLink
            to={`/dashboard${
              systemDomainId ? `/${systemDomainId}/plugin` : ""
            }`}
          >
            <Layers size={23} />
            <span>Dashboard</span>
          </HeaderLink>
          <HeaderLink to={`/job/job`}>
            <Clock size={23} />
            <span>Jobs</span>
          </HeaderLink>
          <HeaderLink to={`/config/organization`}>
            <Settings size={23} />
            <span>Config</span>
          </HeaderLink>
          <HeaderLink to={`/billing`}>
            <DollarSign size={23} />
            <span>Billing</span>
          </HeaderLink>
        </>
      )}
      <Spacer />
      {showLinks && (
        <Button
          icon={LogOut}
          label="Sign out"
          onClick={signOut}
          borderless
          type="default"
        />
      )}
    </StyledHeader>
  );
};

export default Header;
